module.exports = __webpack_public_path__ + "img/bg1.c0a4a332.jpg";